// Shared PostHog event names used across multiple components.
// Single-use events stay as inline strings at the call site.
export const CLICK_COUPON_CTA = 'click coupon cta';
